<platform-page-container [fullscreen]="false" [contentSpacing]="false">
  <div
    class="login-prompt"
    ngClass.lt-md="mobile"
    fxLayout="row"
    fxLayoutAlign="center center"
    data-cy="login-prompt"
  >
    <div fxFlex="65" fxFlex.lt-md="100">
      <h2 [innerHTML]="'login_prompt_title' | translate"></h2>
      <p [innerHTML]="'login_prompt_text' | translate"></p>
      <zelis-button
        [href]="loginUrl"
        [forwardedClass]="[
          'login',
          'margin',
          'top-2x',
          'bottom-5x',
          ccss.loginButtonClass | async
        ]"
        color="accent"
        (clickFn)="productAnalyticsService.setAuthenticationPage()"
      >
        {{ 'app_global_login_register' | translate }}
      </zelis-button>

      <div *ngIf="(alphaPrefix | async)?.home_enabled">
        <h2>{{ 'member_id_prompt_title' | translate }}</h2>
        <p [innerHTML]="'member_id_prompt_text' | translate"></p>
        <div class="alpha-prefix-input">
          <input
            *ngFor="
              let input of arrayOf((alphaPrefix | async)?.length);
              trackBy: trackByFn;
              let i = index
            "
          />
          <zelis-button variant="stroked" color="accent">
            {{ 'smartshopper_schedule' | translate }}
          </zelis-button>
        </div>
      </div>
    </div>
    <div
      fxFlex="35"
      fxHide.lt-md
      class="login-image-container"
      aria-hidden="true"
    >
      <span class="login-circle">
        <img alt="" src="../../assets/images/laptop.svg" />
      </span>
    </div>
  </div>
</platform-page-container>
